export class PassedChallengesApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PassedChallengesApiError';
  }
}
